import axios from "axios";

export const state = {
    theaterpatients: [],
};

export const getters = {
    theaterpatients: state => state.theaterpatients,
};

export const mutations = {
    setPatients(state, newValue) {
        state.theaterpatients = newValue
    },
};

export const actions = {
    fetchTheaterPatients({ commit }) {
        axios.get('/theaterpatients').then(res => {
            commit('setPatients', res.data.visits)
        })
    },
    filterTheaterPatients({commit}, {datefrom,dateto}) { 
        let formData = new FormData();
        formData.append("datefrom", datefrom);
        formData.append("dateto", dateto);
        let url = "/filtertheaterpatients";
        axios.post(url, formData).then((response) => {
            commit('setPatients', response.data.visits)
        })
    },
};
